import { Box, VStack } from '@genial/components';
import React from 'react';
import { FlatList } from 'react-native';

import { TableHeadContainer, TableHeadItem } from '../../../../../../../../components/TableHead';
import { RecommendedPortfolioAssetItem } from '../../../../../../../../store/customerAssetDetail/types';

import { PortfolioAssetItem } from './components/PortfolioAssetItem';
import { portfolioAssetsListItemSeparatorHeight, tableHead } from './constants';

export interface PortfolioAssetsProps {
  assets: RecommendedPortfolioAssetItem[];
}

export const PortfolioAssets: React.FC<PortfolioAssetsProps> = ({ assets }) => {
  return (
    <Box overflow="hidden" mt="inset.xxs">
      <VStack space="stack.nano">
        <TableHeadContainer px="inline.xxxs">
          {tableHead.map((item, index) => (
            <TableHeadItem key={`${item.title}-${index}`} {...item} />
          ))}
        </TableHeadContainer>

        <FlatList<RecommendedPortfolioAssetItem>
          data={assets}
          windowSize={20}
          maxToRenderPerBatch={20}
          updateCellsBatchingPeriod={5}
          keyExtractor={(item, index) => `${item.assetNameNormalized}-${index}`}
          showsVerticalScrollIndicator={false}
          ItemSeparatorComponent={() => <Box height={portfolioAssetsListItemSeparatorHeight} />}
          renderItem={({ item }) => <PortfolioAssetItem asset={item} />}
        />
      </VStack>
    </Box>
  );
};
